import { PATH } from '@/shared/constants';

export const FOOTER_WISHKET_INFO_LINKS = [
  {
    name: '요즘IT 소개',
    link: PATH.YOZM_INTRODUCE,
  },
  {
    name: '작가 지원',
    link: 'https://answer.moaform.com/answers/WyvXJe',
  },
];

export const FOOTER_USAGE_LINKS = [
  {
    name: '콘텐츠 제안하기',
    link: 'https://forms.gle/7m35DgHYAav7ksQN7',
  },
  {
    name: '광고 상품 보기',
    link: 'https://mesquite-puck-04b.notion.site/IT-d8b12ed5fdfd456aa5a00b1350a7a9ef/',
  },
];

export const FOOTER_OTHER_SERVICE_LINKS = [
  {
    name: '요즘IT 슬랙봇',
    link: '/magazine/slackbot/',
    isNewWindow: false,
  },
  {
    name: '크롬 확장 프로그램',
    link: 'https://chrome.google.com/webstore/detail/%EC%9A%94%EC%A6%98it/apbolfnadgepomiacibgiiflpmjglfgo',
    isNewWindow: true,
  },
];

export const EXTERNAL_LINKS = {
  // terms
  TERMS_PRIVACY: 'https://auth.wishket.com/terms/privacy',
  TERMS_SERVICE: 'https://auth.wishket.com/terms/service',
  TERMS_YOUTH_PROTECTION: 'https://auth.wishket.com/terms/youth-protection',
  // other
  YOZMIT: 'https://yozm.wishket.com',
  JOBS: 'https://jobs.wishket.com',
  WISHKET: 'https://www.wishket.com',
};
